module.exports = __webpack_public_path__ + "static/media/RollCall_Android.054a809a.gif";